(() => {
  if (window.smaxupProofTickerLoaded) return;
  window.smaxupProofTickerLoaded = true;
  const clean = clone => {
    clone.setAttribute('aria-hidden', 'true'); clone.setAttribute('data-loop-copy', '');
    [clone, ...clone.querySelectorAll('*')].forEach(el => {
      [...el.attributes].forEach(attr => { if (attr.name === 'id' || attr.name.startsWith('data-shopify-')) el.removeAttribute(attr.name); });
    });
    return clone;
  };
  const initialize = root => {
    if (root.smaxupTickerCleanup) return;
    const track = root.querySelector('.smaxup-proof-ticker__track');
    const group = track?.querySelector('.smaxup-proof-ticker__group');
    if (!group) return;
    const originals = [...group.children];
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const rebuild = () => {
      root.removeAttribute('data-loop-ready');
      [...track.children].filter(el => el !== group).forEach(el => el.remove());
      group.querySelectorAll('[data-loop-copy]').forEach(el => el.remove());
      if (!originals.length) return;
      if (!motion.matches) {
        const baseWidth = group.getBoundingClientRect().width;
        const repetitions = baseWidth > 0 ? Math.ceil(root.clientWidth / baseWidth) : 1;
        for (let i = 1; i < repetitions; i++) for (const item of originals) group.appendChild(clean(item.cloneNode(true)));
        track.appendChild(clean(group.cloneNode(true)));
      }
      const distance = group.getBoundingClientRect().width;
      const speed = Math.max(1, Number(root.dataset.speed) || 32);
      root.style.setProperty('--smaxup-proof-distance', distance + 'px');
      root.style.setProperty('--smaxup-proof-duration', distance / speed + 's');
      root.setAttribute('data-loop-ready', '');
    };
    const observer = new ResizeObserver(rebuild); observer.observe(root);
    motion.addEventListener('change', rebuild);
    document.fonts?.ready.then(() => { if (root.isConnected) rebuild(); });
    root.smaxupTickerCleanup = () => { observer.disconnect(); motion.removeEventListener('change', rebuild); delete root.smaxupTickerCleanup; };
    rebuild();
  };
  const all = (scope = document) => scope.querySelectorAll('[data-smaxup-proof-ticker]').forEach(initialize);
  all();
  document.addEventListener('shopify:section:load', event => all(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-smaxup-proof-ticker]').forEach(root => root.smaxupTickerCleanup?.()));
})();
